import { Icon } from "semantic-ui-react";
import React from "react";

export const SidePanelControl = ({
  onToggle,
  state,
  location,
  closingHint,
  openingHint
}) => {
  const locations = {
    left: { open: "left", closed: "right" },
    right: { open: "right", closed: "left" }
  };

  const hint =
    state === "open"
      ? closingHint || "Close sidebar"
      : openingHint || "Open sidebar";

  const iconName =
    state === "open"
      ? `angle double ${locations[location]["open"]}`
      : `angle double ${locations[location]["closed"]}`;

  const className = `panel__trigger panel__trigger--${location}`;

  return (
    <div className={className} onClick={onToggle}>
      <Icon title={hint} name={iconName} />
    </div>
  );
};
